import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MDBBtn } from 'mdbreact';

import { ObtenerListaMarcasTecdocEnAPI } from "../action/actionCreatorsRequests"
import 'antd/dist/antd.css';

import { Drawer, Row, Col, Select, Input, Checkbox } from 'antd';
import { traducirPagina } from "../librerias/funciones"

import {
    CloseOutlined,
    SearchOutlined,
    SaveOutlined
} from '@ant-design/icons';
const { Option } = Select;


const ManteniminetoMarcasTecdoc = ({ props, configApp }) => {
    const [hayMarcasVehiculo, setHayMarcasVehiculo] = React.useState(false);
    const [obtenerMarcasVehiculo, setObtenerMarcasVehiculo] = React.useState([]);
    const [txtBuscadorMarca, setTxtBuscadorMarca] = React.useState("");


    const modelarDatos = (marcas) => {
        let listaMarca = [];
        let objetoNuevoMarcas = [];
        let contAux = 0;

        for (var i = 0; i < marcas.length; i++) {
            contAux += 1;
            if (contAux <= 3) {
                listaMarca.push({ ID: marcas[i].ID, MARCA: marcas[i].MARCA, SELECCIONADO: marcas[i].SELECCIONADO, VISIBLE: marcas[i].VISIBLE })
                if ((marcas.length - 1) === i) {
                    objetoNuevoMarcas.push({ "lista": listaMarca });
                }
            } else {
                objetoNuevoMarcas.push({ "lista": listaMarca });
                contAux = 0;
                listaMarca = []
                i = (i - 1)
            }
        }
        return objetoNuevoMarcas.length === 0 ? null : objetoNuevoMarcas;
    }

    const buscarEnTabla = (palabraABuscar) => {
        if (palabraABuscar !== "") {
            if (obtenerMarcasVehiculo !== null) {
                let resultadoFiltro = obtenerMarcasVehiculo.filter((item) => item.MARCA.toUpperCase().includes(palabraABuscar.toUpperCase()) || item.MARCA.toUpperCase() === palabraABuscar.toUpperCase())

                if (resultadoFiltro.length > 0) {

                    obtenerMarcasVehiculo.map((registro) => {
                        registro.VISIBLE = false
                    })

                    resultadoFiltro.map((registro) => {
                        const posicon = obtenerMarcasVehiculo.findIndex((item) => item.ID === registro.ID)
                        registro.VISIBLE = true;
                        obtenerMarcasVehiculo[posicon] = registro;
                    })

                    setObtenerMarcasVehiculo([...obtenerMarcasVehiculo])
                } else {
                    obtenerMarcasVehiculo.map((registro) => {
                        registro.VISIBLE = false
                    })
                    setObtenerMarcasVehiculo([...obtenerMarcasVehiculo])
                }
            }
        } else {
            obtenerMarcasVehiculo.map((registro) => {
                registro.VISIBLE = true
            })
            setObtenerMarcasVehiculo([...obtenerMarcasVehiculo])
        }
    }



    const guardarEstadoFormulario = (e, registro) => {
        const posicon = obtenerMarcasVehiculo.findIndex((item) => item.ID === registro.ID)
        registro.SELECCIONADO = e.target.checked;
        obtenerMarcasVehiculo[posicon] = registro;

        setObtenerMarcasVehiculo([...obtenerMarcasVehiculo])

        const SLECCIONADOS = obtenerMarcasVehiculo.filter((registro) => registro.SELECCIONADO === true);


        props.MARCA_SELECCIONADA(SLECCIONADOS)

    }



    if (!hayMarcasVehiculo && props.ABRIR_FICHA) {
        setHayMarcasVehiculo(true)

        ObtenerListaMarcasTecdocEnAPI(10000, 1, 1, "A", null).then(marcas => {
            if (marcas.REGISTROS !== undefined && marcas.REGISTROS !== null && marcas.REGISTROS.length > 0) {

                // const MARCAS_SELECCIONADAS = props.MARCAS.split(";");

                let MARCAS_SELECCIONADAS = []
                props.MARCAS_ALMACEN.map((marca) => {
                    MARCAS_SELECCIONADAS = [...MARCAS_SELECCIONADAS, marca.ID]
                })

                marcas.REGISTROS.map((registro) => {
                    if (MARCAS_SELECCIONADAS.includes(registro.ID)) {
                        registro.SELECCIONADO = true;
                        registro.VISIBLE = true;
                    } else {
                        registro.SELECCIONADO = false;
                        registro.VISIBLE = true;
                    }
                })

                setObtenerMarcasVehiculo(marcas.REGISTROS);
            } else {
                setObtenerMarcasVehiculo(null);
            }
        })

    } else {
        if (!props.ABRIR_FICHA && hayMarcasVehiculo) {
            setTxtBuscadorMarca("")
            setObtenerMarcasVehiculo([])
            setHayMarcasVehiculo(false)

        }
    }

    return (
        <div>
            <Drawer
                width={750}
                onClose={() => {

                    props.CERRAR_FICHA(false)
                }
                }
                visible={props.ABRIR_FICHA}
                closable={false}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ zIndex: '999', color: '#fff' }}>


                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined>
                        <div> {props.title}</div>
                    </div>
                </div>


                <div className="margenMarcaTecdoc" >

                    <div className="grid-container mb-3 mdb-skin" style={{ backgroundColor: '#eee', marginTop: '2px' }}>
                        <div className="grid-item">
                            <input value={txtBuscadorMarca} className="form-control" type="text" aria-label="Search" placeholder={"Búscar marca"} style={{ backgroundColor: "transparent", width: '635px', border: '0px', height: '100%', color: '#000' }} autoComplete="off" onChange={(e) => { buscarEnTabla(e.target.value.trim() !== "" ? e.target.value : ""); setTxtBuscadorMarca(e.target.value.trim() !== "" ? e.target.value : "") }} />
                        </div>

                        <div className="grid-item" >
                            <MDBBtn style={{ border: '0', padding: '6px 5px 5px 7px', margin: '0', boxShadown: 'none', visibility: txtBuscadorMarca === "" ? 'hidden' : 'visible' }} className="btn-matriculav2" onClick={() => { setTxtBuscadorMarca(""); buscarEnTabla(""); }}>  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                        </div>

                        <div className="grid-item barraLateral" ></div>

                        <div className="grid-item">
                            <MDBBtn style={{ border: '0', padding: '6px 1px 5px 7px', margin: '0', boxShadown: 'none' }} className="btn-matricula">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                        </div>
                    </div>


                    {
                        <div className='containerMarcaTecdoc'>


                            {obtenerMarcasVehiculo === null ?
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh' }}> <h3>Actualmente no hay registros</h3> </div>
                                :
                                obtenerMarcasVehiculo.length > 0 ?
                                    modelarDatos(obtenerMarcasVehiculo).map((item, i) =>
                                        <div key={i} id={i} style={{ color: '#000', fontSize: '16px', fontWeight: '500', marginBottom: '10px' }}>
                                            {item.lista.map((row, i) =>
                                                <Checkbox checked={row.SELECCIONADO} style={{ float: 'left', padding: '5px', width: '30%', cursor: 'pointer', display: row.VISIBLE ? '' : 'none' }} onChange={(e) => { guardarEstadoFormulario(e, row) }} ><span>  {row.MARCA}</span> </Checkbox>
                                            )}
                                        </div>

                                    )
                                    :
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh', color: '#000' }}> <div color="mdb-color darken-3" className="spinner-border  fast" role="status" disabled /> </div>
                            }
                        </div>
                    }

                    <div className="menu_mantenimiento" style={{ padding: '20px 0px 0px 0px' }}>
                        <div className="mantenimiento_item1"></div>
                        <div className="mantenimiento_item2">
                            <div className="botonNuevo" style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }} onClick={() => {
                                props.CERRAR_FICHA(false)
                            }}>
                                <SaveOutlined /> {traducirPagina("Continuar")}
                            </div>
                        </div>
                    </div>

                </div>
            </Drawer>
        </div>

    )
}

ManteniminetoMarcasTecdoc.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    ID_SOCIO: PropTypes.number,
    MARCAS: PropTypes.string,
    MARCA_SELECCIONADA: PropTypes.func,
    HAY_MARCA_SELECCIONADA: PropTypes.bool,
    MARCAS_ALMACEN: PropTypes.array,
    CERRAR_FICHA_PADRE: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,

    };
}

export default connect(mapStateToProps)(ManteniminetoMarcasTecdoc);